module.exports = __webpack_public_path__ + "img/img27.17b21083.jpg";